import styled from 'styled-components'

export const CardContainer = styled.div<{ accentColor: string }>`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;

  max-width: 300px;
  min-height: 200px;
  width: 90%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;

  box-shadow: 1px 12px 25px rgba(0, 0, 0, 0.78);
  border-radius: 2em;
  border: none;

  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.modal || '34, 34, 34'})` : '#ffffff'};

  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};

  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }

  @media (max-width: 768px) {
    max-width: none;
    min-height: 60px;
    height: 60px;
    width: auto;
    min-width: 280px;
    bottom: 70px;
    right: 12px;
    left: auto;
    flex-direction: row;
    border-radius: 30px;
    padding: 0;
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em 0.5em 0 1.5em;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`

export const DisciplineLabel = styled.div`
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '207, 207, 207'})` : '#666'};
  font-size: 0.9rem;
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    max-width: 160px;
  }
`

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5em;

  @media (max-width: 768px) {
    display: none;
  }
`

export const TimeDisplay = styled.h3`
  font-size: 2.5rem;
  margin: 0;
  margin-bottom: 0;
  font-weight: 700;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  font-variant-numeric: tabular-nums;

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`

export const TimeSubtext = styled.p`
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '74, 74, 74'})` : '#999'};
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ProgressSection = styled.div`
  width: 100%;
  margin: 1.2rem 0 0 0;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ProgressLabel = styled.span`
  text-align: left;
  font-weight: 600;
  font-size: 0.85rem;
  width: 100%;
  display: block;
  margin-bottom: 0.4rem;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '207, 207, 207'})` : '#666'};

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`

export const ProgressBar = styled.div`
  position: relative;
  width: 100%;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  height: 5px;
  display: block;
  border-radius: 50px;
  overflow: hidden;
`

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: #1edd0e;
  border-radius: 50px;
  transition: width 0.3s ease;
`

export const ProgressValue = styled.span`
  margin-top: 0.4rem;
  text-align: right;
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};

  @media (max-width: 768px) {
    font-size: 0.8rem;
    margin-top: 0.3rem;
  }
`

export const AddedTimeBadge = styled.span`
  display: block;
  width: fit-content;
  margin: 0.5rem 0 0 auto;
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  font-size: 0.65rem;
  font-weight: 600;
  background: ${({ theme }) =>
    theme.isDark ? 'rgba(30, 221, 14, 0.2)' : 'rgba(30, 221, 14, 0.15)'};
  color: #1edd0e;
  border: 1px solid rgba(30, 221, 14, 0.3);

  @media (max-width: 768px) {
    font-size: 0.6rem;
    padding: 0.08rem 0.3rem;
    margin-top: 0.3rem;
  }
`

export const CardFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5em 1.5em;
  border-bottom-left-radius: 2em;
  border-bottom-right-radius: 2em;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 0.5em 0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 4px;
    padding: 0.4em 0;
  }
`

export const Separator = styled.div`
  width: 1px;
  height: 24px;
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#e0e0e0'};
  margin: 0 4px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const PauseIndicator = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 80px;
  font-size: 0.75rem;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['400'] || '74, 74, 74'})` : '#999'};
  font-style: italic;
`

export const MobileLayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 0.75rem;
  gap: 0.5rem;
`

export const MobileButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
`

export const MobileTimeDisplay = styled.h3`
  font-size: 1.5rem;
  margin: 0;
  font-weight: 700;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  font-variant-numeric: tabular-nums;
  flex: 1;
  text-align: center;
  white-space: nowrap;
`
